/**
 * Formats an array of sender objects into a comma-separated string of nicknames
 * @param {Array<{id: number, nickName: string}>|null|undefined} senders - Array of sender objects
 * @returns {string} Comma-separated list of nicknames or '-' if empty
 */

const formatSenders = (senders) => {
    if (Array.isArray(senders) && senders.length) {
        const names = senders
            .map((sender) => sender?.nickName)
            .filter(Boolean)

        if (names.length) {
            return names.join(', ')
        }
    }

    return '-'
}

export default formatSenders
